import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { MeAPI } from '../mock';
import { useAuth } from './AuthContext';

const WatchlistContext = createContext({ ids: [], count: 0, isWatched: () => false, toggle: async () => 'auth' });

export function WatchlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (!user) { setIds([]); return; }
    MeAPI.watchIds().then(setIds).catch(() => setIds([]));
  }, [user]);

  const isWatched = useCallback(
    (type, id) => ids.some(w => w.item_type === type && w.item_id === id),
    [ids]
  );

  const toggle = useCallback(async (type, id) => {
    if (!user) return 'auth';
    if (ids.some(w => w.item_type === type && w.item_id === id)) {
      setIds(prev => prev.filter(w => !(w.item_type === type && w.item_id === id)));
      try { await MeAPI.unwatch(type, id); } catch { /* optimistic */ }
      return 'removed';
    }
    setIds(prev => [...prev, { item_type: type, item_id: id }]);
    try { await MeAPI.watch(type, id); } catch { /* optimistic */ }
    return 'added';
  }, [user, ids]);

  return (
    <WatchlistContext.Provider value={{ ids, count: ids.length, isWatched, toggle }}>
      {children}
    </WatchlistContext.Provider>
  );
}

export const useWatchlist = () => useContext(WatchlistContext);
